import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { errorMessage } from "../../../../../../utils/errorMessage";

export const actionAdminToCreateWholeSaleInvoice = createAsyncThunk(
  "wholeSale/adminCreateInvoice",
  async ({ _id }, thunkAPI) => {
    const token = thunkAPI.getState().adminUserToLogin.adminUserInfo.token;

    try {
      const { data } = await axios.post(
        "/api/wholesale/adminCreateWholeSaleInvoice",
        { _id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return data;
    } catch (error) {
      let { message } = errorMessage(error);

      throw new Error(message);
    }
  },
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  invoice: null,
};

const createWholeSaleInvoiceSlice = createSlice({
  name: "createWholeSaleInvoice",
  initialState,
  reducers: {
    resetCreateWholeSaleInvoice: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.invoice = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionAdminToCreateWholeSaleInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(
        actionAdminToCreateWholeSaleInvoice.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.invoice = action.payload;
        },
      )
      .addCase(
        actionAdminToCreateWholeSaleInvoice.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          state.success = false;
        },
      );
  },
});

const { resetCreateWholeSaleInvoice } = createWholeSaleInvoiceSlice.actions;

const reducerAdminToCreateWholeSaleInvoice =
  createWholeSaleInvoiceSlice.reducer;

export { reducerAdminToCreateWholeSaleInvoice, resetCreateWholeSaleInvoice };
